import { Directive, OnInit } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

const BLACK_LIST: string[] = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];

@Directive({
    selector: '[frqValidCpf]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ValidCpfDirective, multi: true }]
})
export class ValidCpfDirective implements Validator, OnInit {
    private valFn = Validators.nullValidator;

    ngOnInit(): void {
        this.valFn = cpfValidator();
    }

    validate(control: AbstractControl): Record<string, any> {
        return this.valFn(control);
    }
}

export function cpfValidator(): ValidatorFn {
    return (control: AbstractControl): Record<string, any> => {
        const value = control.value;
        const validCpf = isValidCpf(value);
        return validCpf ? null : { invalidCpf: { value } };
    };
}

function isValidCpf(maskedCpf: string): boolean {
    if (!maskedCpf) {
        return true;
    }
    const unmaskedCpf: string = maskedCpf.replace(/[^\d]+/g, '');
    if (!unmaskedCpf) {
        return true;
    }
    if (unmaskedCpf.length !== 11 || isBlackListed(unmaskedCpf)) {
        return false;
    }
    const dvs: string = unmaskedCpf.substring(9);
    const dv1: number = calculateDv(unmaskedCpf.substring(0, 9));
    const dv2: number = calculateDv(unmaskedCpf.substring(0, 10));
    return dvs.charAt(0) === dv1.toString() && dvs.charAt(1) === dv2.toString();
}

function isBlackListed(unmaskedCpf: string): boolean {
    return BLACK_LIST.indexOf(unmaskedCpf) >= 0;
}

function calculateDv(base: string): number {
    const length: number = base.length;
    let sum = 0;
    for (let i = 0; i < length; i++) {
        sum += Number.parseInt(base.charAt(i)) * (length + 1 - i);
    }
    let result: number = 11 - (sum % 11);
    if (result === 10 || result == 11) {
        result = 0;
    }
    return result;
}
